export class NewsletterItemFileLoad {
  public static readonly type = '[NewsletterItemFile] Load';
  constructor(public payload: string) {}
}

export class NewsletterItemFileInitialState {
  public static readonly type = '[NewsletterItemFile] Set initial state';
}
